export default __webpack_public_path__ + "static/media/9.11e72cd7.png";